export const VISUALIZER = '[Visualizer]';
export const CONFIGURATOR = '[Configurator]';
export const CUSTOMER_RATINGS = '[Customer Ratings]';
export const PRODUCT_OVERVIEW = '[Product Overview]';
export const SPECIFICATIONS = '[Specifications]';
export const QUESTIONS_AND_ANSWERS = '[Questions & Answers]';
export const CUSTOMER_REVIEWS = '[Customer Reviews]';
